import { Instance } from "../axios";
import { Routes } from "../_helpers/apiRouteHelper";
import {
    ColumnData,
    PerPageData,
    SavedColumnData,
    login,
    loginError,
    loginSuccess,
    messageText,
} from "../store/actions";

export class AuthenticationService {
    static Login = (data) => {
        return (dispatch) => {
            dispatch(login());
            Instance.post(Routes.auth.login, data)
                .then((response) => {
                    // console.log(" ~ response:", response)
                    localStorage.removeItem("token");
                    localStorage.removeItem("refreshToken");
                    if (response.status === 200) {
                        localStorage.setItem("token", response.data.data.accessToken);
                        localStorage.setItem("refreshToken", response.data.data.refreshToken);
                        let perPage = response.data.data.pageSize > 0 ? response.data.data.pageSize : 10;
                        dispatch(PerPageData(perPage.toString()))
                        dispatch(messageText({ message: response.data.message, msgType: 2 }));
                        // let routes = response.data.data.userRightsModules.map((obj) => {
                        //     return ({
                        //         path: "/" + obj.toLowerCase(),
                        //         title: obj
                        //     })
                        // })
                        // // routes.push({ path: "/email", title: "Email" })
                        // // routes.push({ path: "/profile", title: "Profile" })
                        // // routes.push({ path: "/linksPath", title: "Links" })
                        // console.log("🚀 ~ AuthenticationService ~ .then ~ routes:", routes)
                        // // routes.unshift({ path: "/", title: "Dashboard" })
                        // // routes.unshift({ path: "/approval", title: "Approval" })

                        // // routes.splice(2, 0, { path: "/approval", title: "Approval" })
                        dispatch(loginSuccess({
                            info: response.data.data,
                            // userModules: routes,
                            profilePic: response.data.data.profilePhotoPath,
                            isOutOfOffice: response.data.data.isCOPSOutOfOffice,
                            token: true
                        }));

                        if (response.data.data.lockData) dispatch(ColumnData(JSON.parse(response.data.data.lockData)))
                        if (response.data.data.lockData) dispatch(SavedColumnData(JSON.parse(response.data.data.lockData)))
                    } else {
                        console.log("🚀 ~ file: authentication.js:37 ~ AuthenticationService ~ .then ~ response:", response)
                        dispatch(messageText({ message: "Login Failed!", msgType: 3 }));
                        // dispatch(messageText({ message: response.response.data.message ? response.response.data.message : response.message, msgType: 3 }));
                        // dispatch(loginError(response.message));
                    }
                }).catch((error) => {
                    console.log(" error:", error)
                    localStorage.clear();
                    // dispatch(loginError("Login error"));
                });
        };
    };
}